<template>
  <div class="col-12 d-flex justify-content-end mt-2 mt-sm-0 px-0">
    <router-link to="/your-reservations" class="no-underline d-flex flex-wrap align-items-center justify-content-end">
      <span class="icon mr-2 icon-onlineshopping text-color-brand1" aria-hidden="true"></span>
      <div>{{ $tc('common.goToYourReservations', count()) }}</div>
      <div class="break"></div>
        <small v-if="hasRemainingTime()">{{ $tc('common.reservationValidFor', remainingMinutes()) }}</small>
    </router-link>
  </div>
</template>

<script lang="ts">
import ShoppingCartTimerMixin from '@/mixins/ShoppingCartTimerMixin';
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'LinkShoppingCart',
  mixins: [
    ShoppingCartTimerMixin
  ],
  methods: {
    count() {
      return this.$store.state.transactionTickets.length || 0
    },
  },
});
</script>
<style scoped>
  a {
    text-align: right;
  }
  .icon{
    font-size: 20px;
  }
  small{
    color: #4c4c4c !important;
  }
</style>
